import { CreditTariff } from 'api/Credit/types';
import { Org } from 'api/Orgs/types';
import { formatDateTime } from 'app/helpers/dateTime';
import { pluralize } from 'app/helpers/pluralize';
import useOrgsOptions from 'app/hooks/useOrgsOptions';
import { useDeleteCreditTariff } from 'components/Dashboard/Billing/CreditTariffs/hooks';

import { Popconfirm, Space, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';

const useColumns = (onCreditTariffDeleted: (creditTariffId: string) => void, setUpdatedCreditTariff: (creditTariff: CreditTariff) => void, org?: Org) => {
  const { getOrgNameByOrgId } = useOrgsOptions();
  const { deleteCreditTariff } = useDeleteCreditTariff(onCreditTariffDeleted);

  const columns: ColumnsType<CreditTariff> = [
    {
      title: 'Service',
      render: (_, { creditService }) => creditService.name,
    },
    {
      title: 'Cost',
      render: (_, { price }) => pluralize(Number(price), 'credit'),
    },
    ...(!org ? [ {
      title: 'Organization',
      render: (_, { orgId }) => getOrgNameByOrgId(orgId),
    } ] as ColumnsType<CreditTariff> : []),
    {
      title: 'Created',
      render: (_, { createdAt }) => <Typography.Text style={{ whiteSpace: 'nowrap' }}>{formatDateTime(createdAt)}</Typography.Text>,
    },
    {
      title: 'Updated',
      render: (_, { updatedAt }) => <Typography.Text style={{ whiteSpace: 'nowrap' }}>{formatDateTime(updatedAt)}</Typography.Text>,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, creditTariff) => (
        <Space size="middle">
          <Typography.Link onClick={() => setUpdatedCreditTariff(creditTariff)}>Update</Typography.Link>
          <Popconfirm
            title="Delete the tariff"
            description="Are you sure you want to delete this tariff"
            onConfirm={() => deleteCreditTariff(creditTariff.id)}
          >
            <Typography.Link disabled>Remove</Typography.Link>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return { columns };
};

export default useColumns;
